import { Injectable } from '@angular/core';
import { ITask2ReportContainer } from '../fi-task-v2-report';
import { FiTaskV2ReportService } from './fi-task-v2-report.service';

@Injectable()
export class FiTaskV2ReportDataService {
    private reportContainer: ITask2ReportContainer;

    constructor(private fiTaskV2ReportService: FiTaskV2ReportService) {}

    getReportContainer(): Promise<ITask2ReportContainer> {
        return new Promise<ITask2ReportContainer>((resolve, reject) => {
            if (this.reportContainer) {
                resolve(this.reportContainer);
            } else
                this.fiTaskV2ReportService.getReportContainer().then((reportContainer) => {
                    this.reportContainer = reportContainer;
                    resolve(this.reportContainer);
                }, reject);
        });
    }

    resetReportContainer(): void {
        this.reportContainer = undefined;
    }

    setReportContainer(reportContainer: ITask2ReportContainer): void {
        this.reportContainer = reportContainer;
    }
}
